import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Onboarding from "@/pages/Onboarding";
import CreatorDashboard from "@/pages/CreatorDashboard";
import AffiliatorDashboard from "@/pages/AffiliatorDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import EcommerceDashboard from "@/pages/EcommerceDashboard";
import DemoKOL from "@/pages/DemoKOL";
import MemberDashboard from "@/components/MemberDashboard";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/demo/creator" element={<DemoKOL />} />
      <Route path="/demo/creator-new" element={<MemberDashboard role="beauty_creator" demo />} />
      <Route path="/demo/affiliator-new" element={<MemberDashboard role="affiliator" demo />} />
      <Route path="/demo/admin-new" element={<AdminDashboard demo />} />
      <Route path="/demo/ecommerce" element={<EcommerceDashboard demo />} />
      <Route path="/demo/onboarding" element={<Onboarding />} />
      <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
      <Route path="/creator" element={<ProtectedRoute allow={["beauty_creator"]}><CreatorDashboard /></ProtectedRoute>} />
      <Route path="/affiliator" element={<ProtectedRoute allow={["affiliator"]}><AffiliatorDashboard /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute allow={["manager"]}><AdminDashboard /></ProtectedRoute>} />
      <Route path="/ecommerce" element={<ProtectedRoute allow={["ecommerce_admin"]}><EcommerceDashboard /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
